export default __webpack_public_path__ + "static/atp1-18483621e067bc17876f6a033c0d9675.jpg";